import { render, staticRenderFns } from "./FieldMappingTable.vue?vue&type=template&id=6bcba868&scoped=true&"
import script from "./FieldMappingTable.vue?vue&type=script&lang=js&"
export * from "./FieldMappingTable.vue?vue&type=script&lang=js&"
import style0 from "./FieldMappingTable.vue?vue&type=style&index=0&id=6bcba868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcba868",
  null
  
)

export default component.exports